/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

  $(document).ready(function() {
	if(location.href.indexOf('queesunhombre')  > 0){
      Weglot.switchTo('es');
    }    
  });
